// Zubehör (Accessories) pricing from MAK_Preisliste_Vorlage.xlsx - Auto-generated

export const accessories = {
  briefkasten: {
    name: 'Briefkasten',
    description: 'Einbau-Briefkasten',
    variants: [
      { id: 'standard', label: 'Standard', price: 340.0 },
    ]
  },
}

export const getAccessoryPrice = (accessoryId, variantId) => {
  const accessory = accessories[accessoryId];
  if (!accessory) return 0;
  
  const variant = accessory.variants.find(v => v.id === variantId);
  return variant ? variant.price : 0;
};

export const calculateAccessoriesTotal = (selectedAccessories) => {
  let total = 0;
  const details = [];
  
  Object.entries(selectedAccessories).forEach(([accessoryId, config]) => {
    if (config.enabled && config.variant) {
      const accessory = accessories[accessoryId];
      const variant = accessory?.variants.find(v => v.id === config.variant);
      if (variant) {
        const quantity = config.quantity || 1;
        const subtotal = variant.price * quantity;
        total += subtotal;
        details.push({
          name: accessory.name,
          variant: variant.label,
          quantity,
          unitPrice: variant.price,
          subtotal
        });
      }
    }
  });
  
  return { total, details };
};
